import { CharacterItem, CharacterItemId, CharacterItemType } from "./CharacterItem";

export enum Character 
{
    MrAdventure,
    LMExpolorer
}

export class CharacterItemSelector
{
    private _activeItems: Array<CharacterItem> = [];

    constructor(private characterItems: Array<CharacterItem>)
    {
    }

    public selectItem(item: CharacterItem): void
    {
        if (item.type === CharacterItemType.Head)
        {
            // Remove any existing head items
            this._activeItems = this._activeItems.filter((activeItem) => activeItem.type !== CharacterItemType.Head);
        }

        if (item.type === CharacterItemType.HandHeld)
        {
            // Remove any existing handheld items
            this._activeItems = this._activeItems.filter((activeItem) => activeItem.type !== CharacterItemType.HandHeld);
        }

        if (item.type === CharacterItemType.Face)
        {
            // Remove any existing handheld items
            this._activeItems = this._activeItems.filter((activeItem) => activeItem.type !== CharacterItemType.Face);
        }

        // Check if the item can co-exist with the active items already
        if (this.canItemBeVisible(item, this._activeItems))
        {
            this._activeItems.push(item);
        }
    }

    public deselectItem(item: CharacterItem, character: Character): void 
    {
        if (character === Character.MrAdventure)
        {
            // He must keep his blue hat if we're trying to remove it
            if (item.id === CharacterItemId.BlueHat)
            {
                return;
            }

            // Switch out to his blue hat if we're delecting any hat
            // He must always wear a blue hat
            if (item.type === CharacterItemType.Head)
            {
                let blueHat: CharacterItem = this.allItems.filter(item => item.id === CharacterItemId.BlueHat)[0];
                this.selectItem(blueHat);
            }
        }

        if (character === Character.LMExpolorer)
        {
            // He must keep his blue hat if we're trying to remove it
            if (item.id === CharacterItemId.BrownHat)
            {
                return;
            }

            // Switch out to his blue hat if we're delecting any hat
            // He must always wear a blue hat
            if (item.type === CharacterItemType.Head)
            {
                let brownHat: CharacterItem = this.allItems.filter(item => item.id === CharacterItemId.BrownHat)[0];
                this.selectItem(brownHat);
            }
        }

        if (item.type === CharacterItemType.HandHeld)
        {
            // They must always have a hand if we're deselecting something they are holding
            let baseHand: CharacterItem = this.allItems.filter(item => item.id === CharacterItemId.BaseHand)[0];
            this.selectItem(baseHand);
        }

        this._activeItems = this._activeItems.filter((activeItem) => activeItem.id !== item.id);
    }

    private canItemBeVisible(item: CharacterItem, activeItems: Array<CharacterItem>): boolean
    {
        for (const itemId of item.allowedIdsToBeVisible)
        {
            if (!activeItems.find((activeItem) => activeItem.id === itemId))
            {
                return false;
            }
        }
        return true;
    }

    public resetActiveItems(): void 
    {
        this._activeItems = [];
    }

    public get activeItems(): Array<CharacterItem>
    {
        return this._activeItems;
    }

    public get className(): string 
    {
        let className: string = "";
        this._activeItems.map(item => className += " visible-" + item.id);
        return className;
    }

    public get allItems(): Array<CharacterItem>
    {
        return this.characterItems;
    }
}

